import { useCallback } from "react";
import { useCreateExchangeCodeMutation } from "@/src/auth/services/auth-http.service";
import { getRefreshToken } from "@/src/auth/store/auth-selectors";
import { buildCommunityUrl, buildMainAppUrl } from "@/src/common/lib/subdomain";
import { useAppSelector } from "@/src/common/redux/store";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";

export function useCommunityNavigation() {
	const refreshToken = useAppSelector(getRefreshToken);
	const [createExchangeCode] = useCreateExchangeCodeMutation();

	const navigateWithAuth = useCallback(
		async (targetUrl: string) => {
			if (!refreshToken) {
				window.location.href = targetUrl;
				return;
			}
			try {
				const { code } = await createExchangeCode({ refresh_token: refreshToken }).unwrap();
				window.location.href = `${targetUrl}?auth_code=${encodeURIComponent(code)}`;
			} catch {
				window.location.href = targetUrl;
			}
		},
		[createExchangeCode, refreshToken],
	);

	return {
		goToCreate: () => navigateWithAuth(buildMainAppUrl(ONBOARDING_ROUTES.CREATE_COMMUNITY_PROFILE)),
		goToCommunity: (slug: string) => navigateWithAuth(buildCommunityUrl(slug)),
	};
}
